import { render, staticRenderFns } from "./DraggableItemCursor.vue?vue&type=template&id=2796e404&scoped=true&"
import script from "./DraggableItemCursor.vue?vue&type=script&lang=js&"
export * from "./DraggableItemCursor.vue?vue&type=script&lang=js&"
import style0 from "./DraggableItemCursor.vue?vue&type=style&index=0&id=2796e404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796e404",
  null
  
)

export default component.exports